'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _jss = require('jss');

var _reactJss = require('react-jss');

var _jssNested = require('jss-nested');

var _jssNested2 = _interopRequireDefault(_jssNested);

var _jssGlobal = require('jss-global');

var _jssGlobal2 = _interopRequireDefault(_jssGlobal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var jss = (0, _jss.create)();
jss.use((0, _jssNested2["default"])());
jss.use((0, _jssGlobal2["default"])());

var ThemeProviderCustom = function ThemeProviderCustom(_ref) {
  var children = _ref.children,
      theme = _ref.theme;
  return _react2["default"].createElement(_reactJss.ThemeProvider, {
    jss: jss,
    theme: theme
  }, children);
};

ThemeProviderCustom.propTypes = {
  children: _propTypes2["default"].element.isRequired,
  theme: _propTypes2["default"].object.isRequired
};
exports["default"] = ThemeProviderCustom;